import { createContext, useContext } from 'react';

// Unknown/loading clinic configuration hides optional features by default.
export const PatientClinicContext = createContext({ membershipEnabled: false });
export const usePatientClinic = () => useContext(PatientClinicContext);
